module.exports = __webpack_public_path__ + "files/1f6f3aaf9dd610db7b1eda975ceb3b2a.png";